import { Icon } from "semantic-ui-react";

import React, { useMemo } from "react";

import db from "astrid-firebase/src/db";
import { useCollectionDataOnce, useLoadingValues } from "astrid-firestore/src/hooks";

export default function useStudioOptions({ organizationId }) {
	const [[studios], loading, error] = useLoadingValues(
		useCollectionDataOnce(
			organizationId &&
				db.collection("studios").where("producerId", "==", organizationId).where("active", "==", true),
		),
	);

	const activeStudioOptions = useMemo(
		() =>
			studios
				?.slice()
				.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1))
				.map((studio) => ({
					id: studio.id,
					key: studio.id,
					value: studio.id,
					data: studio,
					text: studio.name,
					content: (
						<span>
							<Icon name="cube" style={{ color: studio.color || "black" }} />
							{studio.name}
						</span>
					),
				})) || [],
		[studios],
	);

	return [activeStudioOptions, loading, error];
}
